module.exports = __webpack_public_path__ + "img/default-img.374c0b4e.jpg";